import React from 'react';
import { Drawer, Typography } from '@mui/material';
import { Close } from "@mui/icons-material";
import BoxPayGrid from '../BoxPayGrid';
import { multiPaymentTransactionListSchema } from './multiPaymentTransactionListSchema';
import { SaltKeyComponent } from '../Developers/Notification Logs/Webhook/AllWebhook';
import CustomButton from '../../reusableComponents/CustomButton';
import { formatDateWithoutSeconds, PAGE_LIST } from '../utils/utils';
import LoadingLogoPage from '../loadingPage/loadingPage';
import { useAuth } from '../../context/API_Client';
import { customToast } from '../../reusableComponents/customToaster/customToast';
import FileSaver from "file-saver";
import HoverToDisplayFullTitle from '../../reusableComponents/HoverToDisplayFullTitle';

const MultiPaymentTransactionList = (props) => {
    const {
        paymentLinkToken,
        multiPaymentAllTransactionList,
        setShowDrawerForTransactionDetail,
        showDrawerForTransactionDetail,
        isTransactionListLoading,
        paymentLinkTransactionFilter,
        setTotalDataCount,
        totalDataCount,
        pageNo,
        pageLimit,
        setPageNo,
        setPageLimit,
    } = props;
    const {
        paymentLinkTransactionData,
        paymentLinkData: { businessUnitName, sessionExpiryTimestamp, transactionDetails, title } = {}
    } = multiPaymentAllTransactionList;

    const { getDownloadFileWithFilters } = useAuth();

    const handleDownloadModal = () => {
        getDownloadFileWithFilters(paymentLinkTransactionFilter, function (data) {
            const contentDisposition = data.headers["content-disposition"];
            const match = contentDisposition.match(/filename="(.+?)"/);
            const contentType = data.headers["content-type"];
            let filename;
            if (match && match[1]) {
                filename = match[1];
            } else {
                filename = "Data.csv";
            }
            const blob = new Blob([data.data], {
                type: contentType,
            });
            FileSaver.saveAs(blob, filename);
            customToast("success", "high", "Download successful");
        },
            function (errorMsg) {
                customToast("error", "high", errorMsg);
            }
        );
    };

    return (
        <div>
            <Drawer
                anchor={'right'}
                open={showDrawerForTransactionDetail}
                onClose={() => setShowDrawerForTransactionDetail(false)}
                PaperProps={{
                    sx: {
                        width: "75%",
                        padding: '2.5rem 2rem',
                        borderRadius: '0.5rem 0 0 0.5rem'
                    },
                }}
            >
                {
                    isTransactionListLoading ? (
                        <LoadingLogoPage />
                    ) : <>
                        <div style={{ textAlign: 'right', marginBottom: "1rem" }}>
                            <Close style={{ height: 20, width: 20, cursor: 'pointer' }} onClick={() => setShowDrawerForTransactionDetail(false)} />
                        </div>
                        <div className='transaction-detail-page-container'>
                            <div className='transaction-detail-page-header'>
                                <Typography className='payment-link-name'>
                                    <HoverToDisplayFullTitle title={title} len={20} />
                                </Typography>
                                <div className='transaction-detail-button-div'>
                                    <div>
                                        {<SaltKeyComponent pass={paymentLinkToken} hidden={false} msz={'Payment link token copied'} label={'Payment Link Token:'} />}
                                    </div>
                                    <div>
                                        <CustomButton
                                            text={"Download CSV"}
                                            type={"primary"}
                                            variant={"contained"}
                                            size={"sm"}
                                            onClick={handleDownloadModal}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='description-box'>
                                <div className='description-unit'>
                                    <Typography className='font-text-low description-unit-header'>Bussiness Unit</Typography>
                                    <Typography>{businessUnitName}</Typography>
                                </div>
                                <div className='description-unit'>
                                    <Typography className='font-text-low description-unit-header'>Expiry</Typography>
                                    <Typography>{sessionExpiryTimestamp && formatDateWithoutSeconds(sessionExpiryTimestamp)}</Typography>
                                </div>
                                <div className='description-unit'>
                                    <Typography className='font-text-low description-unit-header'>Total Payments</Typography>
                                    <Typography>{Object.keys(transactionDetails)?.length}</Typography>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: '1.6rem' }}>
                            <BoxPayGrid
                                schema={multiPaymentTransactionListSchema()}
                                data={paymentLinkTransactionData}
                                loader={isTransactionListLoading}
                                showCustomizeButton={false}
                                customPagination={true}
                                pageNo={pageNo}
                                setPageNo={setPageNo}
                                pageLimit={pageLimit}
                                setPageLimit={setPageLimit}
                                totalDataCount={totalDataCount}
                            />
                        </div>
                    </>
                }
            </Drawer>
        </div>
    )
}

export default MultiPaymentTransactionList